<template>
    <div class="page bg-gray">
        <backTitleBar></backTitleBar>
        <div class="flex-center pd-25 color-fff main-top">
            <div class="top-img"><img :src="iconImg" alt=""></div>
            <div class="flex1 ml-25 mr-25">
                <div class="fs-32 font-bold">{{entity.shopName}}</div>
                <div class="flex fs-28 mt-10">
                    <div>数量：{{entity.lackNum + entity.weighLackNum}}</div>
                    <div class="ml-20" v-if="entity.weighLackWeight != 0">重量：{{entity.weighLackWeight/1000}}kg</div>
                    <div class="ml-20">种类：{{entity.lackItemCount + entity.weighLackItemCount + entity.weighLackWeightCount}}</div>
                </div>
            </div>
            <div class="fs-32 font-bold">待补货</div>
        </div>

        <div class="product-list">
            <div class="product-item fs-26" v-for="(item,$index) in entity.itemList" :key="$index">
                <div class="item-img"><img :src="item.mainPicView" alt=""></div>
                <div class="item-info">
                    <div class="color-000 text-el">{{item.productName}}</div>
                    <div class="mt-10 color-999">缺货:
                        <span class="color-warning" v-if="item.isWeightCalc == 1">{{item.lackNum/1000}}kg</span>
                        <span class="color-warning" v-else>{{item.lackNum}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bot-address">
            <div class="alifont icon-dizhi"></div>
            <div class="fs-28">{{entity.address}}</div>
        </div>
    </div>
</template>

<script>
    import {qryLackShop} from '@/api/product'

    import backTitleBar from "@/components/titleBar/backTitleBar"

    export default {
        name: "disStockCabinetDetail",
        components:{backTitleBar},
        data(){
            return{
                iconImg: require("../../assets/images/warning/w1.png"),
                entity:{},

            }
        },

        created() {
            this.$store.state.showFooter = false;
            this.shopId = this.$route.query.shopId;  //柜子Id
            this.getDetail();
        },
        methods:{
            getDetail(){
                let param = {
                    shopId : this.shopId,
                }
                qryLackShop(param).then(res=>{
                    this.entity = res.data.records[0]
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .top-img{
        width: .96rem;
        height: .96rem;
    }
    .main-top{
        background: $org;
    }
    .product-list{
        padding: .2rem .24rem;
        display: flex;
        flex-wrap: wrap;
        .product-item{
            width: 2.26rem;
            margin-right: .12rem;
            margin-bottom: .12rem;
            background: #fff;
            border-radius: .06rem;
            &:nth-child(3n){
                margin-right: 0;
            }
            .item-img{
                width: 100%;
                height: 2.26rem;
            }
            .item-info{
                padding: .16rem .14rem .2rem;
            }
        }
    }
    .bot-address{
        background: rgba(0,0,0,.7);
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        align-items: center;
        padding: .2rem .24rem;
        color: #fff;
        .alifont{
            font-size: .48rem;
            margin-right: .2rem;
        }
    }
</style>



// WEBPACK FOOTER //
// disStockCabinetDetail.vue?793974de